var prodcat = prodcat || {};
var site = site || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {
  $(document).on('product.init', '.js-product', function () {
    var $product = $(this);
    var skuBaseId;
    var hasDramming;
    var $anchor = $('.js-product-full__anchor', $product);
    var $anchorDetails = $('.js-product-full__data-anchor-link', $product);
    var $body = $('html, body');

    if ($product.hasClass('js-product-full-v3')) {
      /* Values of hasDramming:
        0 - Not a dramming product;
        1 - dramming prodct & foucs on second select box
        noshade - dramming product and don't trigger product_&shade_select_,full_shades,
        full_shades_flyout&_v1.js on init only.
      */
      hasDramming = false;
      skuBaseId = $product.data('sku-base-id');

      if ($product.hasClass('js-product-dramming')) {
        hasDramming = 'noshade';
      }
      $product.trigger('product.skuSelect', [skuBaseId, hasDramming]);
    }

    $anchorDetails.once().click(function(){
      $body.animate({
          scrollTop: $($(this).attr('href')).offset().top
      }, 500);
      return false;
    });

    // Reduce height for the CTA placement
    if ($anchor.is(':empty') && $anchor.is(':first-child')) {
      $anchor.parent('.product-full__data-main').css('min-height','auto');
    }
  });

  $(document).on('product.skuSelect', '.js-product', function (skuBaseId) {
    var $product = $(this);
    var skuData = prodcat.data.getSku(skuBaseId);
    var ingredients;
    var $ilnSection;
    var $ilnData;

    if (!_.isNull(skuData)) {
      ingredients = skuData.ILN_LISTING;
      $ilnSection = $product.find('.js-product-full__data-section--iln');
      $ilnData = $ilnSection.find('.js-product-full-iln-listing');

      if ($ilnSection.length >= 1 && ingredients) {
        $ilnSection.show();
        if ($ilnData.length) {
          $ilnData.html(ingredients);
        }
      } else {
        $ilnSection.hide();
      }
    }
  });

  Drupal.behaviors.productFullV3 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
    },
    attached: false
  };
})(jQuery);
